import { useQuery } from "@tanstack/react-query"

import { BULK_ORDER_QUERY_KEY, BULK_ORDER_LIST_QUERY_KEY } from "@/constants/query"
import { getBulkOrderById, getBulkOrders, getBulkOrdersSelectList } from "@/http/bulkOrder"

import { IRequestParams } from "@/types/api"
import { BulkOrderStateRequest } from "@/types/IBulkOrder"


export const useBulkOrderQuery = (params?: IRequestParams) => {
  return useQuery({
      queryFn: () => getBulkOrders(params || {},  BulkOrderStateRequest.BulkOrder),
      queryKey: [BULK_ORDER_QUERY_KEY, params],
      retry: false
    })
}

export const useBulkOrderSelectListQuery = () => {
    return useQuery({
        queryFn: () => getBulkOrdersSelectList(),
        queryKey: [BULK_ORDER_LIST_QUERY_KEY],
        retry: false
    })
}

export const useBulkOrderByIdQuery = (id: number)  => {
    return useQuery({
        queryFn: () => getBulkOrderById(id),
        queryKey: [BULK_ORDER_QUERY_KEY, id],
        enabled: id !== 0
    })
}
